<!-- Barra de menu-->
<navbar-component></navbar-component>

<main class="background">
  <div style="display: flex; flex-direction: column;">

    <div class="label-wrapper">
      <img class="label" src="assets/fotos/plate-creative-nutrients.svg" />
    </div>

    <button class="button-right" routerLink="/plastics" mat-button>
      <mat-icon class="pipe-img" svgIcon="plastics-pipe"></mat-icon>
    </button>

    <button class="button-left" routerLink="/confections" mat-button>
      <mat-icon class="pipe-img" svgIcon="confections-pipe"></mat-icon>
    </button>

    <button class="button-right" routerLink="/laundry" mat-button>
      <mat-icon class="pipe-img" svgIcon="laundry-pipe"></mat-icon>
    </button>

    <button class="button-left" routerLink="/cria" mat-button>
      <mat-icon class="pipe-img" svgIcon="cria-pipe"></mat-icon>
    </button>

  </div>
</main>

<!-- Footer and copyright -->
<footer-component></footer-component>
